import { Swiper, SwiperSlide } from "swiper/react";
import {
  VideoPopupBox,
  VideoPopupButton,
  VideoPopupButtonWrapper,
  VideoPopupImgBox,
  VideoPopupWrapper,
  ProgressDots,
  VideoPopupImg,
} from "./styles/video-popup";
import { useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import { getImagePopup, ImagePopup } from "../../../../../api/image-popup";
import { openNewWindow } from "../../../../../utils/common";

const VideoPopup = ({
  setIsVideoPopupOpen,
}: {
  setIsVideoPopupOpen: (isOpen: boolean) => void;
}) => {
  const history = useHistory();
  const [currenBannerIndex, setCurrentBannerIndex] = useState(0);

  const [imgList, setImgList] = useState<ImagePopup[]>([]);

  useEffect(() => {
    getImagePopup().then((res) => {
      setImgList(res);
    });
  }, []);

  if (imgList.length === 0) return <></>;

  return (
    <VideoPopupWrapper>
      <VideoPopupBox>
        <VideoPopupImgBox>
          <Swiper
            onRealIndexChange={(swiper: any) =>
              setCurrentBannerIndex(swiper.realIndex || 0)
            }
            slidesPerView={1}
            centeredSlides={true}
            autoplay={{ delay: 4000 }}
          >
            {imgList.map((item, i) => (
              <SwiperSlide key={i}>
                <VideoPopupImg>
                  <img src={item.imagePath} alt="img" />
                </VideoPopupImg>
              </SwiperSlide>
            ))}
          </Swiper>
          {imgList.length > 1 && (
            <ProgressDots>
              {imgList?.map((_, i) => (
                <div
                  key={i}
                  className={`dot ${currenBannerIndex === i ? "active" : ""}`}
                />
              ))}
            </ProgressDots>
          )}
        </VideoPopupImgBox>
        <VideoPopupButtonWrapper>
          <VideoPopupButton
            backgroundColor="#fff"
            color="var(--Purple-300, #6436e7)"
            borderRadius="0 0 0 12px"
            onClick={() => {
              const url = imgList[currenBannerIndex].buttonUrl;
              if (url.includes("runnerrunner")) {
                window.location.href = url;
              } else {
                openNewWindow(url);
              }
              setIsVideoPopupOpen(false);
            }}
          >
            {imgList[currenBannerIndex].buttonText}
          </VideoPopupButton>
          <VideoPopupButton
            backgroundColor="var(--Purple-300, #6436E7)"
            color="#fff"
            borderRadius="0 0 12px 0"
            onClick={() => setIsVideoPopupOpen(false)}
          >
            <span>닫기</span>
          </VideoPopupButton>
        </VideoPopupButtonWrapper>
      </VideoPopupBox>
    </VideoPopupWrapper>
  );
};

export default VideoPopup;
